<template>
    <li class="ed-dropdown-menu__item">
      <slot></slot>
    </li>
</template>

<script>
  export default {
    name: 'DropdownItem',
  };
</script>



// WEBPACK FOOTER //
// dropdownMenuItem.vue?5a106db9